/*
*  页面跳转地址
* */
export const PATH = {
  main: {
    homePage: '/pages/homePage'
  },
  activity: {
    dailyActivity: '/dailyActivity',
    immediatelyActivity: '/immediatelyActivity',
    activeDetail: '/activeDetail',
    activityList: '/activityList',
  },
  // 问卷路径
  surveyQuestionnaire:{
    surveyQuestionnaire: '/surveyQuestionnaire'
  },
  assistMudule: {
    useManual: '/useManual'
  },
  signIn: {
    signIn: '/signIn',
    wxSignIn: '/wxSignIn'
  },
  system: {
    setting: '/setting',
    systemNotice: '/systemNotice'
  },
  questionnaire: {
    questionnaireList: '/questionnaireList',
    questionnaireCode: '/questionnaireCode'
  },
  dpcSystem: {
    orderDirectory: '/orderDirectory',
    oldPeopleOrder: '/oldPeopleOrder',
    newOldPeopleOrder: '/newOldPeopleOrder',
    nursingOrder: '/nursingOrder',
    dpcTakeMeal: '/dpcTakeMeal',
    dpcLogin: '/dpcLogin',
    dailyMenuStatistics:'/dailyMenuStatistics',
    dailyMenuStatisticsDetail:'/dailyMenuStatisticsDetail',
    myDailyMenuStatistics:'/myDailyMenuStatistics',
    myDailyMenuStatisticsDetail:'/myDailyMenuStatisticsDetail',
    recharge:'/dpcSystem/recharge',
    immediatelyOrder:'/immediatelyOrder',
    immediatelyOrderDetail:'/immediatelyOrderDetail',
  },
  outRecord: {
    outRecord: '/outRecord',
    outRecordCount: '/outRecordCount',
    outRecordWithBuilding: '/outRecordWithBuilding'
  },
  outRecordStatistics:{
    outRecordStatistics: '/outRecordStatistics',
    outRecordStatisticsDetail: '/outRecordStatisticsDetail',
    oldpeopleConcernExamine: '/oldpeopleConcernExamine',
  },
  archives: {
    index: '/archives/index',
    nursingTask: {
      nursingTask: '/archives/nursingTask',
      oldpeopleNursingTask: '/archives/oldpeopleNursingTask',
    },
    oldpeople: {
      choose: '/archives/oldpeople/choose'
    },
    nursingItem: {
      choose: '/archives/nursingItem/choose'
    },
    houseShow:{
      buildingStatus: '/archives/houseShow/buildingStatus',
      roomStatus: '/archives/houseShow/roomStatus',
    },
    logistics:{
      waterBottleRegister: '/waterBottleRegister',
      sendWaterRecord: '/sendWaterRecord',
      applyWaterRecord: '/applyWaterRecord',

    },

  },
  homeCare:{
    homeSiteSignIn: '/homeSite/homeSiteSignIn',
  },
  fzkWorkbench:{
    index: '/fzkWorkbench/index',
  }
}



// WEBPACK FOOTER //
// ./src/config/pathConfig.js